import { useEffect, useState } from "react";
import SyIcon from "../../../../../shared/components/sy-icon";
import { Controller, useForm } from "react-hook-form";
import OrbInput from "../../../../../shared/forms/orb-input/orb-input";
import { useDispatch, useSelector } from "react-redux";
import { getAuthDetails } from "../../../../../feature/auth-slice";
import {
  getOrbitDetails,
  setSelectOrbit,
} from "../../../../../feature/orbit-slice";
import styleSheet from "../style.module.scss";
import { useMutation } from "@tanstack/react-query";
import orbitService from "../../../services/orbit-service";
import { useTranslation } from "react-i18next";
import SyTooltip from "../../../../../shared/components/sy-tooltip";

const OrbitManage = (props: any) => {
  const { orbitData, updateOrbitDetails } = props;
  const authSlice = useSelector(getAuthDetails);
  const orbitSlice = useSelector(getOrbitDetails);
  const [editView, setEditView] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const defaultValues = {
    orb_name: "",
    orb_description: "",
    orb_company_id: "",
    orb_status: 1,
    orb_id: "",
  };
  const {
    setValue,
    getValues,
    control,
    watch,
    formState: { errors },
  } = useForm<any>({
    defaultValues: defaultValues,
  });
  const orbName = watch("orb_name");

  const onChangeView = () => {
    if (orbitData.orb_access_type !== 1) return;
    setEditView(!editView);
  };

  const onSaveOrbit = () => {
    const values = getValues();
    editOrbit(values);
  };

  const { mutate: editOrbit, isPending: editOrbitLoading } = useMutation({
    mutationFn: orbitService.editOrbit,
    onSuccess(data, variables, context) {
      setEditView(false);
      updateOrbitDetails();
    },
  });

  const onChangeOrbit = (type: any, value: any) => {
    dispatch(setSelectOrbit(value));
    setEditView(false);
  };

  useEffect(() => {
    setValue("orb_company_id", orbitData.orb_company_id);
    setValue("orb_name", orbitData.orb_name);
    setValue("orb_description", orbitData.orb_description);
    setValue("orb_description", orbitData.orb_description);
    setValue("orb_id", orbitData.orb_id);
  }, [orbitData]);

  return (
    <div>
      {!editView ? (
        <div>
          <p
            className={`${
              orbitSlice.maps ? "font-30" : "font-40"
            } text-white  bebas-neue pointer truncate-1-lines mb-0`}
            onDoubleClick={onChangeView}
          >
            <SyTooltip title={orbitData.orb_name}>
              <span>{orbitData.orb_name}</span>
            </SyTooltip>
          </p>
          <p
            className={`${
              orbitSlice.maps ? "font-30" : "font-40"
            } text-white bebas-neue pointer truncate-1-lines opacity-50 `}
            onDoubleClick={onChangeView}
          >
            <SyTooltip title={orbitData.orb_description}>
              <span>
                {orbitData.orb_description
                  ? orbitData.orb_description
                  : t("type_your_sub_title_here")}
              </span>
            </SyTooltip>
          </p>
        </div>
      ) : (
        <div className="d-flex ">
          <div>
            <Controller
              name={"orb_name"}
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <OrbInput
                    type={"text"}
                    placeholder={t("type_your_title_here")}
                    value={value}
                    onChange={onChange}
                    size={orbitSlice.maps ? "sm" : "md"}
                    className={"mohave-bold truncate-1-lines"}
                  />
                );
              }}
            />

            <Controller
              name={"orb_description"}
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <OrbInput
                    type={"text"}
                    placeholder={t("type_your_sub_title_here")}
                    value={value}
                    onChange={onChange}
                    size={orbitSlice.maps ? "sm" : "md"}
                    className={"mohave-bold truncate-1-lines "}
                  />
                );
              }}
            />
          </div>

          <div className="d-flex align-items-end ">
            {orbName?.trim() && (
              <SyIcon
                name="save"
                iconType="symbols"
                iconStyle="outlined"
                iconColor="white"
                onClick={onSaveOrbit}
                loading={editOrbitLoading}
                className={`font-30 pointer  text-white mb-3 ms-2`}
              />
            )}
          </div>
        </div>
      )}

      <div className="d-flex ">
        {orbitData.position?.left && (
          <SyIcon
            name={"trending_flat"}
            iconColor="rgba(255, 255, 255, 0.3)"
            className={`${styleSheet.rotate} me-4 pointer`}
            onClick={() => {
              onChangeOrbit("pre", orbitData.position?.left);
            }}
            size="md"
          />
        )}

        {orbitData.position?.right && (
          <SyIcon
            name={"trending_flat"}
            iconColor="rgba(255, 255, 255, 0.3)"
            className={"pointer ps-4"}
            onClick={() => {
              onChangeOrbit("next", orbitData.position?.right);
            }}
            size="md"
          />
        )}
      </div>
    </div>
  );
};

export default OrbitManage;
